import { h } from 'preact';
import { Input } from '../Input';
import type { ComponentShowcase } from '../registry';

export const showcase: ComponentShowcase = {
  name: 'Input',
  category: '📝 Formulários',
  description: 'Campo de input com label, erro, ícone e autoFocus',
  usedIn: ['AgentesPage', 'Profile', 'Integrations', 'ChatHubPage'],
  example: () => (
    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
      <Input label="Nome" value="" onChange={() => {}} placeholder="Digite..." />
      <Input label="Com erro" value="" onChange={() => {}} error="Campo obrigatório" />
      <Input label="Com ícone" value="" onChange={() => {}} placeholder="Buscar..." icon="🔍" />
      <Input label="Disabled" value="Valor fixo" onChange={() => {}} disabled />
    </div>
  ),
};
